export default __webpack_public_path__ + "static/media/Facutlyofeng.af4e5087.png";